import React, { ReactElement } from 'react';
import { NotFoundPage } from 'slovlex-idsk-react-components';
import SecuredPageComponent from './component/SecuredPageComponent';
import { useUserContext } from '../../context/UserContext';
import UserRole from '../../model/currentuser/UserRole';

interface Props {
  children: ReactElement;
  allowForRoles?: Array<UserRole>;
  requestStatus?: number;
  additionalCheck?: boolean;
}

const SecuredPage = ({
  children, allowForRoles, requestStatus, additionalCheck,
}: Props): ReactElement => {
  const { pouzivatel } = useUserContext();

  if (requestStatus === 404) {
    return <NotFoundPage />;
  }

  return (
    <SecuredPageComponent
      pouzivatel={pouzivatel}
      allowForRoles={allowForRoles}
      additionalCheck={additionalCheck}
    >
      {children}
    </SecuredPageComponent>
  );
};

export default SecuredPage;
